import type {TranslationFunction} from 'src/types/language-support';

import {MAX_WIDGETS} from 'src/components/analytics-genesis/byod/constants';


export function getWidgetLimitTooltipBody(t: TranslationFunction): string {
  return t('There_is_a_limit_of_adding_up_to_max_reports', {
    max: MAX_WIDGETS,
    defaultValue: 'There is a limit of adding up to {{max}} reports',
  });
}
